<template>
  <section class="partners">
    <div class="partners-container">
      <h3>Ils nous font confiance</h3>
      <div class="partners-logos">
        <div class="partner-item" v-for="partner in partners" :key="partner">
          <span>{{ partner }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PartnersSection',
  data() {
    return {
      partners: [
        'Entreprises',
        'Commerçants',
        'Particuliers',
        'Agriculteurs',
        'Artisans',
        'PME'
      ]
    }
  }
}
</script>

<style scoped>
.partners {
  background: var(--off-white);
  padding: 3rem 2rem;
  border-top: 1px solid var(--gray-100);
  border-bottom: 1px solid var(--gray-100);
}

.partners-container {
  max-width: 1400px;
  margin: 0 auto;
}

.partners h3 {
  text-align: center;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--gray-500);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 2rem;
}

.partners-logos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  flex-wrap: wrap;
}

.partner-item {
  padding: 0.75rem 1.5rem;
  background: var(--white);
  border-radius: 50px;
  border: 1px solid var(--gray-200);
  transition: var(--transition-base);
}

.partner-item span {
  font-weight: 600;
  color: var(--gray-600);
  font-size: 0.9rem;
}

.partner-item:hover {
  border-color: var(--primary-blue);
  box-shadow: var(--shadow-md);
}

.partner-item:hover span {
  color: var(--primary-blue);
}

@media (max-width: 768px) {
  .partners-logos {
    gap: 1rem;
  }

  .partner-item {
    padding: 0.5rem 1rem;
  }
}
</style>
